import React, { useCallback } from "react";
import { useField } from "formik";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import FormControl from "@mui/material/FormControl";
import Input from "../Input";

const ArrayField = ({ label, disabled, ...props }) => {
  const [field, , helpers] = useField(props);
  const fields = field.value || [];
  const fieldName = field.name;

  const handleAddNew = useCallback(() => {
    helpers.setValue(fields.concat(""));
  }, [helpers, fields]);

  const handleRemove = useCallback(
    i => helpers.setValue(fields.filter((v, index) => i !== index)),
    [helpers, fields]
  );

  return (
    <Grid container spacing={1}>
      {fields.map((v, index) => (
        <Grid key={index} size={12}>
          <Box display="flex" alignItems="center">
            <FormControl fullWidth>
              <Input disabled={disabled} name={`${fieldName}.${index}`} label={label} />
            </FormControl>
            {fields.length > 1 && (
              <IconButton
                aria-label="delete"
                sx={{ p: 1, mr: -1 }}
                onClick={() => handleRemove(index)}
              >
                <DeleteIcon color="action" />
              </IconButton>
            )}
          </Box>
        </Grid>
      ))}
      <Grid size={12}>
        <Button
          id={`addNew-${fieldName.split(".").join("-")}`}
          variant="outlined"
          onClick={handleAddNew}
        >
          Add New <AddIcon color="action" fontSize="small" />
        </Button>
      </Grid>
    </Grid>
  );
};

export default React.memo(ArrayField);
